import { doc, getDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { generatePortalToken, buildPortalUrl, getDefaultPortalBaseUrl } from './portalToken';

export async function getPortalBaseUrl(db) {
  try {
    const snap = await getDoc(doc(db, 'config', 'emailAutomation'));
    const base = snap.exists() ? snap.data()?.portalBaseUrl : null;
    if (base && String(base).trim()) {
      return String(base).trim().replace(/\/$/, '');
    }
  } catch (error) {
    console.warn('getPortalBaseUrl:', error);
  }
  return getDefaultPortalBaseUrl();
}

/** Fields to merge when creating a new customer document. */
export function portalFieldsForNewCustomer(overrides = {}) {
  return {
    portalToken: generatePortalToken(),
    portalTokenCreatedAt: new Date(),
    portalLastEmailedAt: null,
    portalEnabled: overrides.portalEnabled !== false
  };
}

export function enrichCustomerDocForCreate(customerData) {
  return {
    ...customerData,
    ...portalFieldsForNewCustomer(customerData)
  };
}

export async function ensureCustomerPortalToken(db, customerId) {
  if (!customerId) return null;

  const customerRef = doc(db, 'customers', customerId);
  const snap = await getDoc(customerRef);
  if (!snap.exists()) return null;

  const data = snap.data();
  if (data.portalToken) return data.portalToken;

  const portalToken = generatePortalToken();
  await updateDoc(customerRef, {
    portalToken,
    portalTokenCreatedAt: serverTimestamp(),
    portalEnabled: data.portalEnabled !== false
  });
  return portalToken;
}

export async function resetCustomerPortalToken(db, customerId) {
  if (!customerId) return null;

  const portalToken = generatePortalToken();
  await updateDoc(doc(db, 'customers', customerId), {
    portalToken,
    portalTokenCreatedAt: serverTimestamp()
  });
  return portalToken;
}

export async function getCustomerPortalUrl(db, customer) {
  if (!customer) return '';

  let token = customer.portalToken;
  if (!token && customer.id) {
    token = await ensureCustomerPortalToken(db, customer.id);
  }
  if (!token) return '';

  const base = await getPortalBaseUrl(db);
  return buildPortalUrl(base, token);
}
